module.exports = __webpack_public_path__ + "img/vision1.517741e5.svg";